// extracted by mini-css-extract-plugin
export default {"details":"pkWIv6gg","adress":"w5HYpHvt","mobile":"mobile","captionWrapper":"f4uKhtEb"};